import { useContext, useEffect } from "react";
import { OperationContext } from "../CreateOperation";
import { useSearchParams } from "react-router";
import { OperationConstant } from "../../../core/_constant";
import { DebarkingConfrontation } from "./debarking/DebarkingConfrontation";
import { EmbarkingConfrontation } from "./embarking/EmbarkingConfrontation";
import { Empty, Radio } from "antd";

export const ConfrontationPage = () => {
  const { initialValue } = useContext(OperationContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const typeFromURL = parseInt(searchParams.get("type") || "");

  const CONFRONTATION_ALL_TYPE = [
    initialValue?.debarkationMovement?.id && {
      label: OperationConstant.LANDING_LABEL,
      value: initialValue?.debarkationMovement?.id,
      component: (
        <DebarkingConfrontation
          movementId={initialValue?.debarkationMovement?.id}
        />
      ),
    },
    ,
    initialValue?.embarkationMovement?.id && {
      label: OperationConstant.BOARDING_LABEL,
      value: initialValue?.embarkationMovement?.id,
      component: (
        <EmbarkingConfrontation
          movementId={initialValue?.embarkationMovement?.id}
        />
      ),
    },
    ,
  ]?.filter((item) => item);

  useEffect(() => {
    const currentType = searchParams.get("type")
    if (!currentType || currentType === "undefined") {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("type", CONFRONTATION_ALL_TYPE[0]?.value.toString());
      setSearchParams(newParams);
    }
  }, [initialValue]);

  const handleChangeConfrontationType = (value: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("type", value?.toString());
    let reachedType = false;
    const keysToDelete: string[] = [];

    newParams.forEach((_, key) => {
      if (reachedType) {
        keysToDelete.push(key);
      }
      if (key === "type") {
        reachedType = true;
      }
    });

    keysToDelete.forEach((key) => newParams.delete(key));

    setSearchParams(newParams);
  };

  const activeComponent =
    CONFRONTATION_ALL_TYPE.find((item) => item.value === typeFromURL)
      ?.component || CONFRONTATION_ALL_TYPE[0]?.component;
  return (
    <div className={``}>
      {
        typeFromURL ? (
          <>
          <div className="">
        <Radio.Group
          onChange={(e) => handleChangeConfrontationType(e.target.value)}
          value={typeFromURL}
          optionType="button"
          buttonStyle="solid"
        >
          {CONFRONTATION_ALL_TYPE?.map((item: any) => (
            <Radio value={item?.value}>{item?.label}</Radio>
          ))}
        </Radio.Group>
      </div>
      <div className="">{activeComponent}</div>
          </>
        ) : (
          <Empty description="En attente de manifeste"/>
        )
      }
    </div>
  );
};
